
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdSave } from 'react-icons/md';
import './AddCustomer.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { CREATE_CUSTOMER_API } from '../config/API';
import Loader from '../components/common/Loader';
import { showErrorToast } from '../utils/toastUtils';

const AddCustomer = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        customerName: '',
        customerPhone: '',
        customerEmail: '',
        customerAdd: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: 'Save Customer?',
            text: 'Do you want to save this customer?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#4f46e5',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn',
            },
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                const token = localStorage.getItem('accessToken');
                const response = await axios.post(CREATE_CUSTOMER_API, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (response.data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Saved!',
                        text: 'Customer created successfully',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    navigate('/customers');
                } else {
                    showErrorToast(response.data.error || response.data.message || 'Failed to create customer');
                }
            } catch (error) {
                console.error('Error creating customer:', error);
                const errorData = error.response?.data?.error || error.response?.data?.message || 'An error occurred';
                showErrorToast(errorData);
            } finally {
                setLoading(false);
            }
        }
    };

    if (loading) {
        return <Loader fullPage text="Creating customer..." />;
    }

    return (
        <div className="add-customer-page">
            <div className="page-header">
                <button onClick={() => navigate('/customers')} className="back-btn">
                    <MdArrowBack />
                </button>
                <h2>Add New Customer</h2>
            </div>

            <form onSubmit={handleSubmit} className="customer-form">
                <div className="form-section">
                    <h3>Customer Details</h3>
                    <div className="form-grid">
                        <div className="form-group full-width">
                            <label>Customer Name <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="customerName"
                                value={formData.customerName}
                                onChange={handleChange}
                                placeholder="Enter customer name"
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone No <span className="required-star">*</span></label>
                            <input
                                type="tel"
                                name="customerPhone"
                                value={formData.customerPhone}
                                onChange={handleChange}
                                placeholder="Enter phone number"
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="customerEmail"
                                value={formData.customerEmail}
                                onChange={handleChange}
                                placeholder="Enter email address"
                            />
                        </div>
                        <div className="form-group full-width">
                            <label>Customer Address</label>
                            <textarea
                                name="customerAdd"
                                value={formData.customerAdd}
                                onChange={handleChange}
                                placeholder="Enter full address"
                                rows="3"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => navigate('/customers')} className="cancel-btn">
                        Cancel
                    </button>
                    <button type="submit" className="save-btn">
                        <MdSave /> Save Customer
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddCustomer;

